<template>
  <div>
    <TeCourseWebdevelopmentAdvancedCover
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />

    <TeCommonPagenav class="hidden md:block">
      <template #courseicon>
        <FontAwesomeIcon
          :icon="faLaptopCode"
          class="fa-fw mr-2 size-5"
        />
      </template>
      <template #coursename>
        Web制作実践<span class="hidden md:inline">コース</span>
      </template>
      <template #menu>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#about'"
            @click.prevent="scrollTo('about')"
          >
            概要
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#price'"
            @click.prevent="scrollTo('price')"
          >
            料金
          </a>
        </li>
        <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#flow'"
            @click.prevent="scrollTo('flow')"
          >
            受講の流れ
          </a>
        </li>
        <!-- 251202導線削除 -->
        <!-- <li>
          <a
            class="block px-4 py-3 text-co-gray-700 hover:text-co-gray-700"
            :href="'#faq'"
            @click.prevent="scrollTo('faq')"
          >
            FAQ
          </a>
        </li> -->
      </template>
    </TeCommonPagenav>

    <TeCommonBannerThousand />

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />
    <TeCommonBannerCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <TeCourseAbout>
      <template #title>
        Web制作実践コースについて
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          1人では続かない方のためのパーソナルメンターがつく学習プログラム。
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          週2回マンツーマンでのメンタリング、毎日のチャット・レビューサポートで
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          Web制作のコーディングスキルアップにつなげることができます。
        </p>
      </template>
    </TeCourseAbout>

    <TeCourseWebdevelopmentAdvancedTarget />

    <TeCommonDemographics />

    <TeCommonTechAcademyWorks :work-example="true" />

    <!-- 副業で活躍中の卒業生 -->
    <section
      id="sidejob-achievement"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-5 py-20">
        <!-- セクションタイトル -->
        <div class="text-center">
          <h2 class="co-heading-2-caption">
            副業で活躍中の卒業生
          </h2>
          <p class="mb-2 text-co-gray-600">
            未経験から副業で活躍中の卒業生を紹介
          </p>
          <span class="co-display-13 mb-[3.25rem] inline-block text-left text-co-gray-500 md:text-center">
            ※個人差があります。すべての方に同様の結果を保証するものではありません。
          </span>
        </div>

        <!-- 卒業生 -->
        <TeCommonGraduateFirstSidejob />
      </div>
    </section>

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-first" /> -->

    <TeCourseWebdevelopmentAdvancedOutput />

    <TeCommonBannerAdobe />

    <!-- 挫折させないパーソナルメンターサポート -->
    <section
      id="mentor-support"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pt-20">
        <h2 class="co-heading-2-caption">
          挫折させない<span class="block md:inline">パーソナルメンターサポート</span>
        </h2>
        <h3 class="co-display-12 mb-[3.25rem] text-left leading-base text-co-gray-600 md:text-center">
          学習時の「わからない」「続かない」を解消し、挫折をなくします。
          <br class="hidden md:block">
          実務で培った技術とノウハウで受講生一人ひとりをサポートします。
        </h3>
        <div class="flex flex-col justify-center gap-x-8 sm:px-36 lg:flex-row lg:px-0">
          <TeCommonMentorSupportMentoring />

          <TeCommonMentorSupportChatSupport />

          <TeCommonMentorSupportIssueReview />
        </div>
      </div>
      <TeCommonMentorSupportAboutFlow>
        <template #flowOriginalText>
          模擬案件に挑戦
        </template>
        <template #learningLead>
          パーソナルメンターとの定期的なメンタリング、チャットサポート、課題レビュー、宿題に取り組みながらスキルを身につけます。
        </template>
        <template #originalTitle>
          実践的な模擬案件にチャレンジ
        </template>
        <template #originalLead>
          パーソナルメンターが徹底サポートのもと、実案件と同様の工程で模擬案件に取り組んでいただきます。
        </template>
      </TeCommonMentorSupportAboutFlow>

      <TeCommonMentorSupportMentor :one-column="true">
        <template #mentorImage1>
          <img
            class="size-full object-cover"
            src="~/assets/images/Te/TeCommon/MentorSupport/Mentor/mentor-hachiya.jpg"
            alt="Satoshi Hachiya"
            width="213"
            height="213"
            loading="lazy"
          >
        </template>
        <template #mentorName1>
          Satoshi
          <br>
          Hachiya
        </template>
        <template #mentorProfile1>
          Javaプログラマー・NW保守を経て、現在はウェブサイトの運用保守チームで開発サポートと分析業務に携わっています。
        </template>
        <template #mentorMessage1>
          「わからない」を知り、理解しながら学習を進めて頂けるようサポートいたします。学ぶことを楽しみながら、実践的なスキルを身につけましょう！
        </template>
      </TeCommonMentorSupportMentor>

      <TeCommonMentorSupportReason />
    </section>

    <TeCommonLearningCycle>
      <template #image>
        <img
          class="mx-auto w-3/4 sm:w-1/2 md:w-full"
          src="~/assets/images/Te/TeCommon/LearningCycle/cycle-webdevelopment.svg"
          alt="学習サイクル デザイン"
          loading="lazy"
        >
      </template>
      <template #catchOne>
        カリキュラムを<span class="text-co-primary-500">読む</span>
      </template>
      <template #textOne>
        テックアカデミーのオンラインオリジナル学習システムを使って、自ら学習を進めていただきます。カリキュラムは最新情報をすぐにアップデートできるよう、テキストベースで作成されています。
      </template>
      <template #catchTwo>
        模擬案件に<span class="text-co-primary-500">挑戦する</span>
      </template>
      <template #textTwo>
        知識を「学ぶ」だけでなく、実際に「使える」ようになるために、実践に近い形で制作します。
      </template>
      <template #catchThree>
        疑問点をメンターに<span class="text-co-primary-500">質問する</span>
      </template>
      <template #textThree>
        自習していてわからないところを1人で悩まずに、すぐにメンターに聞いて解決することが重要です。オンラインで常駐している現役のプロのメンターが、あなたの質問に素早く回答します。
      </template>
    </TeCommonLearningCycle>

    <TeCourseReviewsTwitter />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-second" /> -->

    <TeCommonCampaign
      :course-name-path="courseNamePath"
      :current-promotion="currentPromotion"
    />

    <section
      id="price"
      class="co-bg-striped"
    >
      <!-- 無料相談割引コード -->
      <TeCommonBannerTimeLimitCpnCode
        v-if="BannerNameForShowing === 'campaign'"
        :entry-campaign="entryCampaign"
      />

      <div class="co-container-lg px-4 py-20 xl:px-0">
        <h2 class="co-display-7 mb-[3.25rem] text-center">
          料金
        </h2>

        <TeCommonPriceTimeLimit
          v-if="BannerNameForShowing === 'discount'"
          :entry-discount-time-limit="entryDiscountTimeLimit"
        />

        <TeCourseWebdevelopmentAdvancedPriceTable
          :course="course"
          :latest-cohort="latestCohort"
          :current-promotion="currentPromotion"
        >
          <template #additionalFees>
            Adobe Creative Cloud Pro 個人版のご利用に対し、3ヶ月分クーポンを発行いたします。3ヶ月以降、ご利用になる場合は別途料金（月額7,780円、2025年7月30日時点）が発生します。受講料には含まれませんのでご注意ください。
          </template>
        </TeCourseWebdevelopmentAdvancedPriceTable>

        <!-- クラウドローンバナー -->
        <!-- Educareテスト開始、クラウドローンバナーはコメントアウト -->
        <!-- <TeCommonBannerCrowdloan /> -->

        <!-- 参加条件 -->
        <TeCommonPriceParticipationconditions>
          <template #conditionList>
            <li class="mb-2">
              JavaScript・jQueryを使用してWebサイトを制作したことがある
            </li>
            <li class="mb-2">
              必要なメンタリング回数をこなすことが出来る
            </li>
            <li class="mb-2">
              期間内に必要な学習時間を確保出来る
            </li>
            <li class="mb-2">
              MacかWindowsのPCを持っている
            </li>
            <li class="mb-2">
              PCスペック：Photoshopの最小技術仕様を満たしている
              <span class="inline md:block">
                （詳細な内容は
                <a
                  href="https://helpx.adobe.com/jp/photoshop/system-requirements.html"
                  target="_blank"
                >こちら</a>
                ）
              </span>
            </li>
            <li class="mb-2">
              Google Chrome を利用できる
            </li>
            <li class="mb-2">
              PCの基本的な操作が問題なくできる
            </li>
            <li>ビデオチャットが可能な通信環境</li>
          </template>
        </TeCommonPriceParticipationconditions>

        <div class="flex flex-col items-center lg:flex-row lg:items-start lg:gap-x-8">
          <!-- 注意事項 -->
          <TeCommonPricePrecautions>
            <template #preCautionsList>
              <li class="mb-2">
                支払い方法はクレジットカード払い（分割可能）、コンビニ決済、銀行振込、Amazon Pay、PayPayからお選びいただけます。
              </li>
              <li class="mb-2">
                クレジットカード払いは、Visa、Master、JCB、AMEX、Dinersに対応しています。
              </li>
              <li class="mb-2">
                カード分割払いご利用回数（3/5/6/10/12/15/18/20/24）
              </li>
              <li class="mb-2">
                Dinersは分割の支払いが利用できません。
              </li>
              <li class="mb-2">
                コンビニ決済は30万円を超える支払いにはご利用いただけません。
              </li>
              <li class="mb-2">
                50万円を超えるPayPay決済をご利用の際は、本人確認の認証が必要となります。
              </li>
              <li class="mb-2">
                請求書払いをご希望の場合はお申込後、専用のフォームからご申請ください。
              </li>
              <li class="mb-2">
                決済後、専用のフォームから領収書の発行が可能です。
              </li>
              <li class="mb-2">
                参加にはウェブカメラ、マイクが必要となります。
              </li>
              <li>12/28から1/3はメンターサポート休止期間です。受講期間がサポート休止期間にかかる場合、受講が最大7日間延長されます。</li>
            </template>
          </TeCommonPricePrecautions>
          <!-- キャンセルポリシー -->
          <TeCommonPriceCancelPolicy />
        </div>
      </div>
    </section>

    <TeCourseSakiwari
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
    >
      <template #plan>
        <div class="flex w-full flex-col rounded border-co-gray-950/[.125] bg-co-gray-50 p-5 text-co-gray-700 lg:w-[270px]">
          <h3 class="te-text-sakiwari-blue co-display-11 m-0 border-0 pb-4 pt-1 font-bold md:pb-3">
            プランを選ぶ
          </h3>
          <img
            class="mx-auto mb-4 block max-w-full"
            src="~/assets/images/Te/TeCommon/Sakiwari/sakiwari-step2_12weeks.png"
            loading="lazy"
            alt="プランを選ぶ"
          >
          <p class="co-display-12 mb-0 text-left text-gray-700">
            プランは12週間プランをお選びください。
          </p>
        </div>
      </template>
    </TeCourseSakiwari>
    <TeCommonTomowari
      bg="#ab89c3"
      title-bg="#9367b2"
    />

    <!-- キャリアアップ支援事業 -->
    <TeCommonCareerUp
      :course="course"
      :course12weeks="true"
    />

    <!-- 251202導線削除 -->
    <!-- <TeCommonBannerFreeTrial id="cta-third" /> -->

    <TeCommonComparisonSchoolSidejob :mentoring="true" />

    <TeCourseWebdevelopmentAdvancedFlow />

    <!-- 251202導線削除 -->
    <!-- <TeCourseWebdevelopmentAdvancedFaQ /> -->

    <!-- 無料相談割引コード -->
    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCourseApply
      :course="course"
      :cohorts="cohorts"
      :latest-cohort="latestCohort"
      :sakiwari-cohorts="sakiwariCohorts"
      :current-promotion="currentPromotion"
      :course-name-path="courseNamePath"
      :entry-discount-time-limit="entryDiscountTimeLimit"
      :entry-campaign="entryCampaign"
    />

    <!-- 下部固定ボタン -->
    <!-- 251202導線削除 -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import {
  getCohorts,
  getCurrentPromotion,
  getCourse,
  getFirstOpenedWholeCohort,
} from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'

import TeCourseWebdevelopmentAdvancedCover from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedCover.vue'
import TeCommonPagenav from '~/components/Te/TeCommon/Pagenav/TeCommonPagenav.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerThousand from '~/components/Te/TeCommon/Banner/TeCommonBannerThousand/TeCommonBannerThousand.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeCommonBannerCampaign from '~/components/Te/TeCommon/Banner/TeCommonBannerCampaign/TeCommonBannerCampaign.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseWebdevelopmentAdvancedTarget from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedTarget.vue'
import TeCommonDemographics from '~/components/Te/TeCommon/TeCommonDemographics/TeCommonDemographics.vue'
import TeCommonTechAcademyWorks from '~/components/Te/TeCommon/TeCommonTechAcademyWorks/TeCommonTechAcademyWorks.vue'
import TeCommonGraduateFirstSidejob from '~/components/Te/TeCommon/Graduate/TeCommonGraduateFirstSidejob.vue'
import TeCommonBannerFreeTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerFreeTrial/TeCommonBannerFreeTrial.vue'
import TeCourseWebdevelopmentAdvancedOutput from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedOutput.vue'
import TeCommonBannerAdobe from '~/components/Te/TeCommon/Banner/TeCommonBannerAdobe/TeCommonBannerAdobe.vue'
import TeCommonMentorSupportMentoring from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportMentoring/TeCommonMentorSupportMentoring.vue'
import TeCommonMentorSupportChatSupport from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportChatSupport/TeCommonMentorSupportChatSupport.vue'
import TeCommonMentorSupportIssueReview from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportIssueReview/TeCommonMentorSupportIssueReview.vue'
import TeCommonMentorSupportAboutFlow from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportAboutFlow/TeCommonMentorSupportAboutFlow.vue'
import TeCommonMentorSupportMentor from '~/components/Te/TeCommon/MentorSupportMentor/TeCommonMentorSupportMentor.vue'
import TeCommonMentorSupportReason from '~/components/Te/TeCommon/MentorSupport/TeCommonMentorSupportReason/TeCommonMentorSupportReason.vue'
import TeCommonLearningCycle from '~/components/Te/TeCommon/TeCommonLearningCycle/TeCommonLearningCycle.vue'
import TeCourseReviewsTwitter from '~/components/Te/TeCourse/TeCourseReviewsTwitter.vue'
import TeCommonCampaign from '~/components/Te/TeCommon/TeCommonCampaign/TeCommonCampaign.vue'
import TeCommonPriceTimeLimit from '~/components/Te/TeCommon/Price/TeCommonPriceTimeLimit/TeCommonPriceTimeLimit.vue'
import TeCourseWebdevelopmentAdvancedPriceTable from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedPriceTable.vue'
import TeCommonPriceParticipationconditions from '~/components/Te/TeCommon/Price/TeCommonPriceParticipationconditions/TeCommonPriceParticipationconditions.vue'
import TeCommonBannerCrowdloan from '~/components/Te/TeCommon/Banner/Crowdloan/TeCommonBannerCrowdloan.vue'
import TeCommonPricePrecautions from '~/components/Te/TeCommon/Price/TeCommonPricePrecautions/TeCommonPricePrecautions.vue'
import TeCommonPriceCancelPolicy from '~/components/Te/TeCommon/Price/TeCommonPriceCancelPolicy/TeCommonPriceCancelPolicy.vue'
import TeCourseSakiwari from '~/components/Te/TeCourse/TeCourseSakiwari.vue'
import TeCommonTomowari from '~/components/Te/TeCommon/Tomowari/TeCommonTomowari.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCommonComparisonSchoolSidejob from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchoolSidejob/TeCommonComparisonSchoolSidejob.vue'
import TeCourseWebdevelopmentAdvancedFlow from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedFlow.vue'
import TeCourseWebdevelopmentAdvancedFaQ from '~/components/Te/TeCourse/WebdevelopmentAdvanced/TeCourseWebdevelopmentAdvancedFaQ.vue'
import TeCourseApply from '~/components/Te/TeCourse/TeCourseApply.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faLaptopCode } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = 'web-practice'
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
      faLaptopCode,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true,
      criteoScript: true,
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title:
        'フロントエンドのスキルを身につけ模擬案件に挑戦する講座 | テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '【テックアカデミー(TechAcademy)】フロントエンドの技術をつかった副業の模擬案件に取り組み、短期間でWeb制作の副業ができるようになる講座。専属のパーソナルメンターと一緒に実際の副業の案件に挑戦します。受講者数No.1のオンラインプログラミングスクール。専属のパーソナルメンターがマンツーマンでサポート。',
            twitterTitle: 'Web制作実践コース/受講者数No.1 テックアカデミー',
            twitterDescription:
              'フロントエンドの技術をつかった副業の模擬案件に取り組み、短期間でWeb制作の副業ができるようになる講座。専属のパーソナルメンターと一緒に実際の副業の案件に挑戦します。',
            twitterImage:
              '/_nuxt/ogp/te/tecourse/og-image-webdevelopment-advanced.jpg',
            ogTitle: 'Web制作実践コース/受講者数No.1 テックアカデミー',
            ogDescription:
              'フロントエンドの技術をつかった副業の模擬案件に取り組み、短期間でWeb制作の副業ができるようになる講座。専属のパーソナルメンターと一緒に実際の副業の案件に挑戦します。',
            ogUrl: '/course/webdevelopment-advanced',
            ogImage:
              '/_nuxt/ogp/te/tecourse/og-image-webdevelopment-advanced.jpg',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags.script,
      noscript: scriptTags.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    getCohorts(this.$api, {
      course_screen_name: this.courseNamePath,
      sakiwari: true,
    }).then((response) => {
      this.sakiwariCohorts = response.data
    })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    getFirstOpenedWholeCohort(this.$api).then((response) => {
      this.firstOpenedWholeCohort = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseWebdevelopmentAdvancedCover,
    TeCommonPagenav,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerThousand,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeCommonBannerCampaign,
    TeCourseAbout,
    TeCourseWebdevelopmentAdvancedTarget,
    TeCommonDemographics,
    TeCommonTechAcademyWorks,
    TeCommonGraduateFirstSidejob,
    TeCommonBannerFreeTrial,
    TeCourseWebdevelopmentAdvancedOutput,
    TeCommonBannerAdobe,
    TeCommonMentorSupportMentoring,
    TeCommonMentorSupportChatSupport,
    TeCommonMentorSupportIssueReview,
    TeCommonMentorSupportAboutFlow,
    TeCommonMentorSupportMentor,
    TeCommonMentorSupportReason,
    TeCommonLearningCycle,
    TeCourseReviewsTwitter,
    TeCommonCampaign,
    TeCommonPriceTimeLimit,
    TeCourseWebdevelopmentAdvancedPriceTable,
    TeCommonPriceParticipationconditions,
    TeCommonPricePrecautions,
    TeCommonBannerCrowdloan,
    TeCommonPriceCancelPolicy,
    TeCourseSakiwari,
    TeCommonTomowari,
    TeCommonCareerUp,
    TeCommonComparisonSchoolSidejob,
    TeCourseWebdevelopmentAdvancedFlow,
    TeCourseWebdevelopmentAdvancedFaQ,
    TeCourseApply,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
